import { render, staticRenderFns } from "./ManageSubContractors.vue?vue&type=template&id=32c1ae18&scoped=true"
import script from "./ManageSubContractors.vue?vue&type=script&lang=js"
export * from "./ManageSubContractors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c1ae18",
  null
  
)

export default component.exports